import React, { useMemo } from 'react';
import OrganizationAnalyticsBarChart from './OrganizationAnalyticsBarChart';
import { mapIdsToLabels } from './chartUtils';

const OrganizationChatterTotalChatsByChatterChart = ({ data, chatterLabelMap, pending }) => {
  const { categories, series } = useMemo(
    () => ({
      categories: mapIdsToLabels(data?.chatterIds, chatterLabelMap),
      series: [{ name: 'Chats', data: data?.chats || [] }],
    }),
    [data, chatterLabelMap],
  );

  return (
    <OrganizationAnalyticsBarChart
      title="Total Chats By Chatter"
      subtitle="Chat volume for the selected chatters."
      categories={categories}
      series={series}
      pending={pending}
      emptyText="Select creators and chatters to load chat totals."
      valueType="number"
    />
  );
};

export default OrganizationChatterTotalChatsByChatterChart;
